import { ComplexEntityTypes } from "../../../../utils/constants";
import { ALL_ENTITIES } from "../entityOverviewPage/TableView/EntitiesOverviewTableView";
import { getAllEntitiesColumns } from "./allEntitiesColumns";
import { getAppColumns } from "./appColumns";

import { getDataStoreColumns } from "./datastoreColumns";
import { getHostColumns } from "./hostColumns";
import { getNHIColumns } from "./nhiColumns";
import { getServerColumns } from "./serverColumns";
import { getSharedColumns } from "./sharedColumns";
import { getSharedColumnsMultiTenant } from "./sharedColumnsMultiTenant";
import { getUserColumns } from "./userColumns";

// TODO - Consider if the runtimes icons for OS/Image column are relevant or not
const runtimeIcons = {
  PYTHON: "",
  JAVA: "",
  DOTNET: "",
  RUBY: "",
  OS_ONLY: "",
};

export default function getTableColumns(
  entityType,
  fetchedEntities,
  assets,
  colors,
  showLocalTime,
  selectedTenantIds,
  hasMultipleSelectedTenants
) {
  const columns = hasMultipleSelectedTenants
    ? [...getSharedColumnsMultiTenant(assets, colors)]
    : [...getSharedColumns(assets)];

  if (entityType === ComplexEntityTypes.USER) {
    const extraColumns = getUserColumns(colors, fetchedEntities, showLocalTime);
    if ("department" in extraColumns)
      columns.splice(3, 0, extraColumns.department);
    columns.push(extraColumns.privileged_in);
    columns.push(extraColumns.last_active);
  }

  if (entityType === ComplexEntityTypes.HOST) {
    const extraColumns = getHostColumns(colors, showLocalTime);
    columns.splice(3, 0, extraColumns.os);
    columns.push(extraColumns.vulnerabilities);
    columns.push(extraColumns.connected_user);
    columns.push(extraColumns.last_seen);
  }

  if (entityType === ComplexEntityTypes.SERVER) {
    const extraColumns = getServerColumns(colors);
    columns.splice(3, 0, extraColumns.type);
    columns.splice(4, 0, extraColumns.os);
    columns.splice(5, 0, extraColumns.os_version);
    columns.splice(6, 0, extraColumns.image_description);
    columns.push(extraColumns.vulnerabilities);
    columns.push(extraColumns.internet_exposure);
  }

  if (entityType === ComplexEntityTypes.DATA_STORE) {
    const extraColumns = getDataStoreColumns(colors);
    columns.splice(3, 0, extraColumns.type);
    columns.push(extraColumns.public_access);
    columns.push(extraColumns.vulnerabilities);
  }

  if (entityType === ComplexEntityTypes.NONHUMAN_IDENTITY) {
    const extraColumns = getNHIColumns(colors, showLocalTime);
    columns.splice(3, 0, extraColumns.type);
    columns.push(extraColumns.lastUsed);
    columns.push(extraColumns.expirationDate);
  }

  if (entityType === ComplexEntityTypes.APP) {
    const extraColumns = getAppColumns(colors);
    columns.push(extraColumns.isUsingAI);
    columns.push(extraColumns.yourDataIsUsedForTraining);
  }

  if (entityType === ALL_ENTITIES) {
    const extraColumns = getAllEntitiesColumns(colors, showLocalTime);
    columns.unshift(extraColumns.entityType);
    columns.push(extraColumns.vulnerabilities);
    columns.push(extraColumns.last_seen);
  }

  return columns;
}
